import {Html5QrcodeScanner} from 'html5-qrcode'
import {FC, useEffect} from 'react'
import {useFormContext} from 'react-hook-form'

interface Props {
  prevStep: () => void
  nextStep: () => void
  stepper: any
  goToFirstStep: () => void
  goToStep: (index: number) => void
}

const FormStep2Parking: FC<Props> = ({prevStep, nextStep, stepper, goToFirstStep, goToStep}) => {
  const {
    // register,
    setValue,
    // watch,
    // control,
    // formState: {
    //   // errors
    // },
    // setError,
  } = useFormContext()
  useEffect(() => {
    let html5QrcodeScanner = new Html5QrcodeScanner(
      'reader',
      {fps: 10, qrbox: {width: 250, height: 250}},
      /* verbose= */ false,
    )

    html5QrcodeScanner.render(onScanSuccess, onScanFailure)

    return () => {
      html5QrcodeScanner.clear()
    }
  }, [])

  function onScanSuccess(decodedText: any, decodedResult: any) {
    try {
      if (decodedText) {
        setValue('fromCamera', true)
        setValue('numeroDocumento', decodedText)
        prevStep()
      }
    } catch (error) {}
  }

  function onScanFailure(error: any) {
    try {
      console.warn(`Code scan error = ${error}`)
      // Aquí podrías mostrar un mensaje de error al usuario si es necesario.
    } catch (error) {
      console.error('Error al manejar el escaneo fallido:', error)
    }
  }

  return (
    <div className='w-100'>
      <div className='pb-10 pb-lg-15'>
        <div className='fw-bold fs-6'>Porfavor escanea el codigo</div>
      </div>
      <div className='row'>
        <div className='row'>
          <div id='reader' style={{width: '600px'}}></div>
        </div>
        {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
      </div>
      <div className='d-flex flex-stack pt-15'>
        <div className='mr-2'>
          <button
            type='button'
            className='btn btn-lg btn-light-primary me-3'
            data-kt-stepper-action='previous'
            onClick={() => goToStep(1)}
          >
            Atras
          </button>
        </div>
      </div>
    </div>
  )
}

export {FormStep2Parking}
